export const version = "abi/5.5.0";
